import { Component } from '@angular/core';

import { FooterComponent, TopbarComponent } from '@serkanyarar/shared';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-bank',
  templateUrl: './bank-component.html',
  styleUrls: ['./bank-component.scss'],
  imports: [TopbarComponent, FooterComponent, TranslocoModule],
  providers: [],
})
export class BankComponent {}
